require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports'], factory);else if ('undefined' != typeof exports) factory(exports);else {
    var mod = {
      exports: {}
    };
    factory(mod.exports), global.command = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports["default"] = function (usage, description, init, aliases) {
    return Array.isArray(init) && (aliases = init, init = void 0), aliases && Array.isArray(aliases) && (usage = [].concat([usage], aliases)), 0 === this.details.commands.filter(function (item) {
      return item.usage === usage;
    }).length && this.details.commands.push({
      usage: usage,
      description: description,
      init: 'function' == typeof init && init
    }), this;
  };
});